import { UPLOADER_TYPE } from '../MultipleMediaUpload/constants';

export { UPLOADER_TYPE };

export const API_FILE_CATEGORY_MAP = {
  [UPLOADER_TYPE.IMAGE]: 'photos',
  [UPLOADER_TYPE.VIDEO]: 'videos'
};